import type filterZh from '../zh/filter';

const filter: typeof filterZh = {
  selected: 'Selected',
  clear: 'Clear all',
  remove: 'Remove {{name}} filter'
};

export default filter;
